// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__aNLIM","productName":"Table_productName__SXEx-"};